<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed, defineProps } from "vue";

const props = defineProps({
    to: { type: String, required: true },
});

const route = useRoute();

const isActive = computed(() => route.path === props.to);
</script>

<template>
    <router-link :to="to">
        <span
            class="hover:bg-white hover:text-black px-3 h-full flex items-center uppercase font-medium"
            :class="isActive ? 'bg-white text-black' : ''"
        >
            <slot />
        </span>
    </router-link>
</template>
